import { render } from "./OrderFormContact.vue?vue&type=template&id=379415bc"
import script from "./OrderFormContact.vue?vue&type=script&lang=js"
export * from "./OrderFormContact.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__